module.exports = __webpack_public_path__ + "img/search.efce5860.png";